import React, { useState } from 'react';
import { List } from 'lucide-react';
import EstadoCuentaSocioModal from './EstadoCuentaSocioModal.jsx';

/**
 * Botón "Estado de Cuenta" por fila de Socios (`resources.socios.js#extraRowActions`,
 * consumido por `ResourcePage` genérico). Componente propio (no una función suelta)
 * porque necesita estado propio (abrir/cerrar el modal) -- mismo patrón que
 * `pages/usuarios/PermisosButton.jsx`. Ícono `List` (equivalente al `fa-list` que V1
 * usa en `ListadoSocios.jsx#jalaMovs`), tamaño 15, siguiendo la convención de
 * `ResourcePage.jsx`.
 *
 * Gate: además de `socios:ver` (que ya gatea toda la página), el endpoint que
 * alimenta el modal (`GET /reportes/estado-cuenta/socio/:socio`) se protege con
 * `reportes:ver` en el backend (flag `menuReportes` de V1, no `menuSocios` -- ver
 * `reportes.routes.js`), así que el botón se oculta si el usuario no tiene también
 * ese permiso.
 */
export default function EstadoCuentaSocioButton({ row, hasPermiso }) {
  const [abierto, setAbierto] = useState(false);

  if (!hasPermiso('reportes:ver')) return null;

  return (
    <>
      <button
        title="Estado de Cuenta" aria-label="Estado de Cuenta"
        className="p-1.5 rounded-md text-primary-600 hover:bg-primary-50"
        onClick={() => setAbierto(true)}
      >
        <List size={15} />
      </button>
      {abierto && <EstadoCuentaSocioModal socio={row} onClose={() => setAbierto(false)} />}
    </>
  );
}
